import { GenIcon } from '../helpers/IconBase.es.js';

const LeftRoundedOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 10 20", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M8.62411 20C8.51444 20.0006 8.40572 19.9796 8.30419 19.9381C8.20266 19.8966 8.11031 19.8355 8.03245 19.7583L1.22411 12.95C0.836088 12.5629 0.528231 12.1031 0.318177 11.5969C0.108123 11.0907 0 10.548 0 9.99998C0 9.45192 0.108123 8.90924 0.318177 8.40303C0.528231 7.89683 0.836088 7.43703 1.22411 7.04998L8.03245 0.241658C8.11015 0.163959 8.20239 0.102325 8.30391 0.0602752C8.40543 0.018225 8.51423 -0.00341797 8.62411 -0.00341797C8.734 -0.00341797 8.8428 0.018225 8.94432 0.0602752C9.04584 0.102325 9.13808 0.163959 9.21578 0.241658C9.29348 0.319357 9.35511 0.411599 9.39716 0.513117C9.43921 0.614635 9.46086 0.723441 9.46086 0.833324C9.46086 0.943207 9.43921 1.05201 9.39716 1.15353C9.35511 1.25505 9.29348 1.34729 9.21578 1.42499L2.40745 8.23331C1.93928 8.70207 1.67631 9.33748 1.67631 9.99998C1.67631 10.6625 1.93928 11.2979 2.40745 11.7666L9.21578 18.575C9.29389 18.6524 9.35588 18.7446 9.39819 18.8462C9.4405 18.9477 9.46228 19.0566 9.46228 19.1666C9.46228 19.2766 9.4405 19.3856 9.39819 19.4871C9.35588 19.5887 9.29389 19.6808 9.21578 19.7583C9.13791 19.8355 9.04557 19.8966 8.94404 19.9381C8.84251 19.9796 8.73379 20.0006 8.62411 20Z",
          fill: "#1B1D29"
        }
      }
    ]
  })(props);
};

export { LeftRoundedOutlined };
